const initialState = {
  theme: { button: { color: 'blue' } }
};

export default initialState;
